import React from "react";

// Statistic tracking scripts
export const statisticTracking = () => {
    return (
        <script>
            {`
            (function(l,e,a,d,i,n,f,o){if(!l[i]){l.GlobalLeadinfoNamespace=l.GlobalLeadinfoNamespace||[];
            l.GlobalLeadinfoNamespace.push(i);l[i]=function(){(l[i].q=l[i].q||[]).push(arguments)};l[i].t=l[i].t||n;
            l[i].q=l[i].q||[];o=e.createElement(a);f=e.getElementsByTagName(a)[0];o.async=1;o.src=d;f.parentNode.insertBefore(o,f);}
            }(window,document,'script','https://cdn.leadinfo.eu/ping.js','leadinfo','LI-66F544AADD111'));
            `}
        </script>
    );
};

// Statistic tracking scripts
export const personalization = () => {
    return (
        <link
            href={`https://fonts.googleapis.com/css2?family=Signika:wght@400;700&family=Source+Sans+Pro:ital,wght@0,400;0,700;1,400&family=Source+Code+Pro:wght@600&display=swap`}
            rel={`stylesheet`}/>
    );
};
